import { getAuthHeaders } from './apiUtils';

export async function fetchSavedDocumentType(patientId, documentId) {
  const headers = await getAuthHeaders();
  const response = await fetch(`/api/v3/patients/${encodeURIComponent(patientId)}/documents/${encodeURIComponent(documentId)}/type`, {
    credentials: 'include', headers: { ...headers, Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Document layout unavailable');
  const data = await response.json();
  if (!data.documentType) throw new Error('Document layout unavailable');
  return data;
}
